export default __webpack_public_path__ + "static/media/chapter4.2997cdce.png";